// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attrs-tooltip-icon{width:16px;height:16px;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;cursor:default;flex-shrink:0;margin-left:3px;opacity:.7}.wrap-of-attrs .item,.wrap-of-attrs li{scroll-margin-top:80px}@media(min-width:640px){.wrap-of-attrs .item,.wrap-of-attrs li{scroll-margin-top:30px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
